// extracted by mini-css-extract-plugin
export default {"header":"Header_header__U1IiE","main-image":"Header_main-image__GewFZ"};